import { format, getQuarter, getYear } from 'date-fns'

import { Aggregate } from '../types'

export function formatDateByAggregate({
  aggregate,
  isoDate,
  variant,
}: {
  aggregate: Aggregate
  isoDate: string
  variant?: 'long' | 'short'
}): string {
  const date = new Date(isoDate)

  switch (aggregate) {
    case 'monthly': {
      const formattingVariant = variant === 'long' ? 'LLLL' : 'LLL'
      return format(date, formattingVariant).toUpperCase()
    }
    case 'quarterly':
      return `Q${getQuarter(date)}`
    case 'yearly':
      return getYear(date).toString()
  }
  exhaustiveCheck(aggregate)
}

export function exhaustiveCheck(param: never): never {
  throw new Error('should not reach here')
}
